import { axiosInstance } from '../clients/axiosClient';
import { DOCTORS_API_PREFIX, API_V1_PREFIX } from '../utils/constants';
import {
  CreateDoctorRequestPydantic,
  CreateUserResponse,
  ListDoctorsResponse,
  UpdateDoctorRequestPydantic,
  UpdateDoctorResponse
} from '../types/apiGeneratedTypes';
import { DoctorLoadStrategy } from '../types/apiGeneratedTypes';

export const getDoctorsList = async (
  offset: number = 0,
  limit: number = 10,
  loading_strategy: DoctorLoadStrategy = DoctorLoadStrategy.AllData,
  sort_by?: string,
  sort_direction?: 'asc' | 'desc',
): Promise<ListDoctorsResponse> => {
  try {
    const params = new URLSearchParams({
      loading_strategy: loading_strategy.toString(),
      limit: limit.toString(),
      offset: offset.toString(),
    });

    if (sort_direction) {params.append('sort_direction', sort_direction);}
    if (sort_by) {params.append('sort_by', sort_by);}

    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${DOCTORS_API_PREFIX}list?${params.toString()}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to fetch doctors');
  }
};


export const createDoctor = async (
  newDoctorRequestObject: CreateDoctorRequestPydantic
): Promise<CreateUserResponse> => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${DOCTORS_API_PREFIX}`,
      newDoctorRequestObject
    );

    return data;
  } catch (error: any) {
    throw error;
  }
};

export const updateDoctor = async (
  doctorRequestObject: UpdateDoctorRequestPydantic
): Promise<UpdateDoctorResponse> => {
  try {
    const { data } = await axiosInstance.patch(
      `${API_V1_PREFIX}${DOCTORS_API_PREFIX}`,
      doctorRequestObject
    );

    return data;
  } catch (error: any) {
    throw error;
  }
};

export const activateDoctor = async (doctorId: string) => {
  const response = await axiosInstance.patch(
    `${API_V1_PREFIX}${DOCTORS_API_PREFIX}activate`,
    {
      doctor_id: doctorId
    }
  );
  return response.data;
};

export const deactivateDoctor = async (doctorId: string) => {
  const response = await axiosInstance.patch(
    `${API_V1_PREFIX}${DOCTORS_API_PREFIX}deactivate`,
    {
      doctor_id: doctorId
    }
  );
  return response.data;
};
